export const pluralize = (count: number, noun: string, suffix = 's') =>
  `${count} ${noun}${count !== 1 ? suffix : ''}`;

export const includesQuery = (
  query: string,
  fields: (string | null | undefined)[],
): boolean => {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;

  return fields.some((field) => field?.toLowerCase().includes(needle));
};
